import { Button, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllActiveOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import { classNames } from 'src/utilities';
import { listPractitionersFromAllOrgs } from '../../../../store/actions/practitioner.action';
import { pushTemplateOverrides } from '../../../../store/actions/templateoverrides.action';

const TemplatesAdminTarget = ({
  selectedTemplatesDataSource,
  onSuccessfulPush,
}) => {
  const dispatch = useDispatch();
  const [organizationDropdown, setOrganizationDropdown] = useState([]);
  const [practitionerDropdown, setPractitionerDropdown] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [selectedPractitioners, setSelectedPractitioners] = useState([]);
  const [practitionerPayload, setPractitionerPayload] = useState([]);

  const {
    allDestinationPractitionerNamesOrgUuids,
    allDestinationPractitionerNamesOrgUuidsLoading,
  } = useSelector((state) => state.doctorsState);

  useEffect(() => {
    dispatch(getAllActiveOrganizationAction());
  }, [dispatch]);

  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let orgData = [];
      getActiveOrganizationsList.forEach((key) => {
        orgData.push({
          label: key?.org_name,
          value: key?.org_uuid,
        });
      });
      setOrganizationDropdown(orgData);
    }
  }, [getActiveOrganizationsList]);

  useEffect(() => {
    if (selectedOrganizations.length > 0) {
      dispatch(
        listPractitionersFromAllOrgs(selectedOrganizations, 'destination')
      );
    } else {
      setPractitionerDropdown([]);
    }
  }, [dispatch, selectedOrganizations]);

  useEffect(() => {
    if (allDestinationPractitionerNamesOrgUuidsLoading === false) {
      setPractitionerDropdown(
        allDestinationPractitionerNamesOrgUuids.map((item) => ({
          label: item.practitioner_name,
          value: item.practitioner_id,
          org_uuid: item.org_uuid,
        }))
      );
    }
  }, [
    allDestinationPractitionerNamesOrgUuids,
    allDestinationPractitionerNamesOrgUuidsLoading,
  ]);

  const handleAssignTemplates = () => {
    const practitionerMap = practitionerPayload.reduce((acc, item) => {
      if (!acc[item.org_uuid]) {
        acc[item.org_uuid] = [];
      }
      acc[item.org_uuid].push(item.practitioner_id);
      return acc;
    }, {});

    dispatch(
      pushTemplateOverrides(
        selectedTemplatesDataSource.map((item) => ({
          template_override_id: item.template_overrides_id,
          org_uuid: item.org_uuid,
        })),
        selectedOrganizations,
        practitionerMap,
        setSelectedOrganizations,
        setSelectedPractitioners,
        onSuccessfulPush
      )
    );
  };

  return (
    <>
      <div className="flex-1">
        <div className="flex flex-col gap-1">
          <div className="text-lg font-bold font-sans pl-1 mb-2">Target</div>
          <Select
            mode="multiple"
            showSearch={true}
            optionFilterProp="label"
            style={{ width: '100%' }}
            options={organizationDropdown}
            placeholder="Select organization(s)"
            value={selectedOrganizations}
            onChange={(values) => {
              setSelectedOrganizations(values);
            }}
            className={classNames('font-sans w-full', 'single-select')}
          />
          <Select
            mode="multiple"
            showSearch={true}
            optionFilterProp="label"
            style={{ width: '100%' }}
            options={practitionerDropdown}
            placeholder="Select practitioner(s)"
            value={selectedPractitioners}
            onChange={(values, option) => {
              setSelectedPractitioners(values);
              setPractitionerPayload(
                option.map((item) => ({
                  practitioner_id: item.value,
                  org_uuid: item.org_uuid,
                }))
              );
            }}
            className={classNames('font-sans w-full', 'single-select')}
          />
          <div className="flex justify-end mt-2">
            <Button type="primary" onClick={handleAssignTemplates}>
              Push templates
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplatesAdminTarget;
